import { faFileInvoice as solidFileInvoice, faRectangleList as solidRectangleList, } from "@fortawesome/free-solid-svg-icons";
import { faBadgePercent, faChartPieAlt, faFileInvoice, faGift, faRectangleList, faUserCog, } from "@fortawesome/pro-regular-svg-icons";
import { faChartPieSimple, faBadgePercent as solidBadgePercent, faGift as solidGift, faUserCog as solidUserCog, } from "@fortawesome/pro-solid-svg-icons";
import { isSecuredInstallment as isSecuredInstallmentLoan } from "../..";
import { accountDetailsModalContainerId, accountServicesModalContainerId, activityModalContainerId, promotionsModalContainerId, rewardsModalContainerId, statementsModalContainerId, } from "../../../const/modalContainerId";
import i18n from "../../../strings/i18n";
import isLoan from "../../isLoan";
import shouldShowAccountServiceButton from "../accountServiceButton/shouldShowAccountServiceButton";
// eslint-disable-next-line max-lines-per-function
var footerIconButtons = function (_a) {
    var _b, _c, _d;
    var handleActivityClick = _a.handleActivityClick, handleDetailsClick = _a.handleDetailsClick, handleStatementsClick = _a.handleStatementsClick, handleRewardsClick = _a.handleRewardsClick, handleAccountServicesClick = _a.handleAccountServicesClick, handlePromotionsClick = _a.handlePromotionsClick, featuresData = _a.featuresData, accountId = _a.accountId, accountSummary = _a.accountSummary, isPredelivery = _a.isPredelivery, featureFlags = _a.featureFlags;
    var hasAccountStatements = featuresData === null || featuresData === void 0 ? void 0 : featuresData.accessToStatements;
    var hasAccountPromotions = featuresData === null || featuresData === void 0 ? void 0 : featuresData.accessToPromotions;
    var hasAccountRewards = (_b = featuresData === null || featuresData === void 0 ? void 0 : featuresData.rewardDetails) === null || _b === void 0 ? void 0 : _b.accessToRewards;
    var isSecuredInstallment = isSecuredInstallmentLoan((_c = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _c === void 0 ? void 0 : _c.type);
    var shouldShowActivitiesButtonForSecuredInstallment = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.showActivityForSecuredInstallment;
    var isSecuredInstallmentLoanAndShouldHide = isSecuredInstallment && !shouldShowActivitiesButtonForSecuredInstallment;
    var activityButton = {
        title: i18n({ labels: "activityBtn" }),
        restIcon: faRectangleList,
        activeIcon: solidRectangleList,
        handleClick: handleActivityClick,
        attributes: {
            dataReason: "activity",
            dataType: "activity",
            id: "activity-button-".concat(accountId),
            containerId: activityModalContainerId(accountId),
        },
        conditions: !isSecuredInstallmentLoanAndShouldHide,
    };
    var detailsButton = {
        title: i18n({ labels: "detailsBtn" }),
        restIcon: faChartPieAlt,
        activeIcon: faChartPieSimple,
        handleClick: handleDetailsClick,
        attributes: {
            dataReason: "account details",
            dataType: "account details",
            id: "accountdetails-button-".concat(accountId),
            containerId: accountDetailsModalContainerId(accountId),
        },
        conditions: true,
    };
    var statementsButton = {
        title: i18n({ labels: "statementsBtn" }),
        restIcon: faFileInvoice,
        activeIcon: solidFileInvoice,
        handleClick: handleStatementsClick,
        attributes: {
            dataReason: "statements",
            dataType: "statements",
            id: "statements-button-".concat(accountId),
            containerId: statementsModalContainerId(accountId),
        },
        conditions: hasAccountStatements &&
            !isLoan((_d = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _d === void 0 ? void 0 : _d.type),
    };
    var rewardsButton = {
        title: i18n({ labels: "rewardsBtn" }),
        restIcon: faGift,
        activeIcon: solidGift,
        handleClick: handleRewardsClick,
        attributes: {
            dataReason: "rewards",
            dataType: "rewards",
            id: "rewards-button",
            containerId: rewardsModalContainerId(accountId),
        },
        conditions: hasAccountRewards && !isSecuredInstallment,
    };
    var accountServicesButton = {
        title: i18n({ labels: "accountServicesBtn" }),
        restIcon: faUserCog,
        activeIcon: solidUserCog,
        handleClick: handleAccountServicesClick,
        attributes: {
            dataReason: "account services",
            dataType: "account services",
            id: "accountServices-button-".concat(accountId),
            containerId: accountServicesModalContainerId(accountId),
        },
        conditions: !isSecuredInstallment &&
            shouldShowAccountServiceButton({ accountSummary: accountSummary, featuresData: featuresData }),
    };
    var promotionsButton = {
        title: i18n({ labels: "promotionsBtn" }),
        restIcon: faBadgePercent,
        activeIcon: solidBadgePercent,
        handleClick: handlePromotionsClick,
        attributes: {
            dataReason: "promotions",
            dataType: "promotions",
            id: "promotions-button-".concat(accountId),
            containerId: promotionsModalContainerId(accountId),
        },
        conditions: hasAccountPromotions && !(isSecuredInstallment || isPredelivery),
    };
    var footerButtons = [
        activityButton,
        statementsButton,
        rewardsButton,
        detailsButton,
        promotionsButton,
        accountServicesButton,
    ];
    var buttonsToDisplay = footerButtons.filter(function (btn) {
        return btn.conditions && btn.handleClick !== undefined && !!btn.handleClick;
    });
    var moreMenuButtons = buttonsToDisplay.filter(function (_btn, i) { return i > 2; });
    var initialThreeButtons = buttonsToDisplay.filter(function (_btn, i) { return i < 3; });
    var hasLessThanFourButtons = buttonsToDisplay.length < 4;
    var isOnlyOneButtonPresent = buttonsToDisplay.length === 1;
    return {
        buttonsToDisplay: buttonsToDisplay,
        moreMenuButtons: moreMenuButtons,
        initialThreeButtons: initialThreeButtons,
        hasLessThanFourButtons: hasLessThanFourButtons,
        isOnlyOneButtonPresent: isOnlyOneButtonPresent,
    };
};
export default footerIconButtons;
//# sourceMappingURL=footerIconButtons.js.map